export default class PhoneNumber {
    constructor(input: string | string[]) {
        if (typeof input === 'string') {
            const digits = input.replace(/-/g, '');
            this.areaCode = digits.substring(0, 3);
            this.prefix = digits.substring(3, 6);
            this.lineNumber = digits.substring(6, 10);
        } else {
            [this.areaCode, this.prefix, this.lineNumber] = input;
        }
    }

    areaCode: string;

    prefix: string;

    lineNumber: string;

    get digits() {
        return `${this.areaCode}${this.prefix}${this.lineNumber}`;
    }

    get isNotBlank() {
        return this.toString().length > 0;
    }

    withAreaCode(areaCode: string) {
        return new PhoneNumber([areaCode, this.prefix, this.lineNumber]);
    }

    withPrefix(prefix: string) {
        return new PhoneNumber([this.areaCode, prefix, this.lineNumber]);
    }

    withLineNumber(lineNumber: string) {
        return new PhoneNumber([this.areaCode, this.prefix, lineNumber]);
    }

    get isValid() {
        return /\d{10}/.test(this.digits);
    }

    toString() {
        if (this.digits.length === 10) {
            return `${this.areaCode}-${this.prefix}-${this.lineNumber}`;
        }
        return this.digits;
    }

    copy() {
        return new PhoneNumber([this.areaCode, this.prefix, this.lineNumber]);
    }
}
